import type { Code } from '../models/code.interface';

interface CodesResponse {
  codes?: Code[];
}

export class SingleApiService {
  fetchCodes(keyIds?: string[]): Promise<Code[]> {
    const headers: Record<string, string> = {};

    const userId = localStorage.getItem('single_customer_id');
    const email = localStorage.getItem('single_customer_email');

    if (userId) headers['x-single-shopify-user-id'] = userId;
    if (email) headers['x-single-shopify-user-email'] = email;

    const url = new URL('/apps/single/v3/content/perks', window.location.origin);
    if (keyIds && keyIds.length > 0) {
      url.searchParams.set('keyIds', keyIds.join(','));
    }

    return fetch(url.toString(), {
      method: 'POST',
      headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data: CodesResponse) => data?.codes || []);
  }
}
